import { h } from 'preact';
import { useState } from 'preact/hooks';
import classNames from 'classnames';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import Button from '../../button/button';

interface Props {
	text: string;
	key: string;
	icon: BringgFontIcons;
	onClick: () => void;
	className?: string;
}

type LoaderButtonProps = Props & {
	onClick: () => Promise<any>;
	loadingConfig: LoadingConfig;
};

export interface LoadingConfig {
	icon: BringgFontIcons;
	text: string;
}

export const SideNavButton = ({ text, key, icon, onClick, className }: Props) => {
	return (
		<Button
			className={classNames('side-nav-button', 'item', className)}
			testId="side-nav-button"
			name={key}
			key={key}
			onClick={onClick}
			ariaLabel={text}
		>
			<BringgIcon iconName={icon} aria-hidden={true} />
			<span className="text" aria-hidden={true}>
				{text}
			</span>
		</Button>
	);
};

export const LoadingSideNavButton = ({ text, key, icon, onClick, loadingConfig }: LoaderButtonProps) => {
	const [isLoading, setIsLoading] = useState(false);
	const newIcon = isLoading ? loadingConfig.icon : icon;
	const newText = isLoading ? loadingConfig.text : text;
	const newOnClick = async () => {
		setIsLoading(true);
		try {
			await onClick();
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<SideNavButton
			className={isLoading ? 'loading' : null}
			key={key}
			onClick={newOnClick}
			icon={newIcon}
			text={newText}
		/>
	);
};
